var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"color":"admin","dark":"","outlined":""},on:{"click":_vm.onConfig}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-clock")]),_vm._v("Cấu hình Hạn đăng ký Chung ")],1),_c('ConfigDialog',{ref:"config-dialog"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }